import React, { useEffect } from 'react';
import { useOrganizacion } from '../context/OrganizacionContext';

const ThemeProvider = ({ children }) => {
  const { config } = useOrganizacion();

  useEffect(() => {
    // Aplicar colores personalizados como variables CSS
    if (config.color_primario) {
      document.documentElement.style.setProperty('--color-primario', config.color_primario);
    }
    if (config.color_secundario) {
      document.documentElement.style.setProperty('--color-secundario', config.color_secundario);
    }

    // Agregar estilos dinámicos para botones y elementos
    const styleId = 'custom-theme-styles';
    let styleElement = document.getElementById(styleId);
    
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    styleElement.textContent = `
      /* Botones primarios */
      .btn-primary,
      button.bg-blue-600,
      button.bg-blue-500,
      .bg-blue-600,
      .bg-blue-500 {
        background-color: ${config.color_primario} !important;
      }

      .btn-primary:hover,
      button.bg-blue-600:hover,
      button.bg-blue-500:hover,
      .hover\\:bg-blue-700:hover,
      .hover\\:bg-blue-600:hover {
        background-color: ${adjustColor(config.color_primario, -20)} !important;
      }

      /* Bordes y texto primario */
      .border-blue-600,
      .border-blue-500 {
        border-color: ${config.color_primario} !important;
      }

      .text-blue-600,
      .text-blue-500 {
        color: ${config.color_primario} !important;
      }

      /* Elementos secundarios */
      .bg-blue-700,
      .bg-blue-800 {
        background-color: ${config.color_secundario} !important;
      }

      /* Focus rings */
      .focus\\:ring-blue-500:focus,
      .focus\\:ring-blue-600:focus {
        --tw-ring-color: ${config.color_primario} !important;
      }

      .focus\\:border-blue-500:focus,
      .focus\\:border-blue-600:focus {
        border-color: ${config.color_primario} !important;
      }

      /* Links */
      a.text-blue-600,
      a.text-blue-500 {
        color: ${config.color_primario} !important;
      }

      a.text-blue-600:hover,
      a.text-blue-500:hover {
        color: ${adjustColor(config.color_primario, -20)} !important;
      }

      /* Badges y pills */
      .bg-blue-100 {
        background-color: ${adjustColor(config.color_primario, 80)} !important;
      }

      .text-blue-800 {
        color: ${adjustColor(config.color_primario, -40)} !important;
      }

      /* Progress bars */
      .bg-gradient-to-r.from-blue-500.to-blue-600 {
        background: linear-gradient(to right, ${config.color_primario}, ${config.color_secundario}) !important;
      }
    `;
  }, [config.color_primario, config.color_secundario]);

  return <>{children}</>;
};

// Función auxiliar para ajustar el brillo de un color
function adjustColor(color, amount) {
  const clamp = (val) => Math.min(Math.max(val, 0), 255);
  
  const num = parseInt(color.replace('#', ''), 16);
  const r = clamp((num >> 16) + amount);
  const g = clamp(((num >> 8) & 0x00FF) + amount);
  const b = clamp((num & 0x0000FF) + amount);
  
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}

export default ThemeProvider;
